import { RnIcon } from '@/components';

export default {
	name: 'rn-error-view',
	components: {
		RnIcon,
	},
};
